import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import api from '../../services/MainAPI';

import BlueHeader from '../components/UI_Components/Header';
import LateralNavigation from '../components/UI_Components/LateralNavigation';

let checkLogin = false;

export default function Home() {
  const navigate = useNavigate();

  const [primaryAuth, setPrimaryAuth] = useState([]);

  async function checkLoginFunction() {
    if (!checkLogin) {
      const userToken = localStorage.getItem('@alliancesystem/token');
      const res = await api.get('/auth/primaryauth', {}, { headers: { Authorization: userToken } });
      if (res.data.error) {
        navigate('/alliancesystem/login');
      } else {
        setPrimaryAuth(res.data);
        checkLogin = true;
      }
    }
  }

  checkLoginFunction();

  return (
    <>
      <Helmet>
        <title>Área do GAP - AllianceSystem</title>
      </Helmet>
      <BlueHeader primaryAuthData={primaryAuth} sectorColor="gapHeader" />
      <LateralNavigation primaryAuthData={primaryAuth} navigationSector="GAP" defaultTab={{ value: true, name: 'Voltar ao Início', url: '/' }} />
    </>
  );
}
